import React from 'react';
import './OnboardingStep.css';

const OnboardingFinalStep = ({
  stepNumber,
  totalSteps,
  value,
  onChange,
  onNext,
  onBack
}) => {
  return (
    <div className="onboarding-step-container">
      <div className="step-progress">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={`step-circle ${index + 1 <= stepNumber ? 'active' : ''}`}
          />
        ))}
      </div>

      <div className="step-card">
        <p className="step-label">STEP {stepNumber}/{totalSteps}</p>
        <h2 className="step-title">Onboarding</h2>
        <p className="step-subtitle">Anything you’d like to say</p>

        <textarea
          className="final-textarea"
          placeholder="Type your thoughts here..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />

        <div className="step-footer">
          <button className="back-btn" onClick={onBack}>← Back</button>
          <button className="back-btn" onClick={onNext}>Skip</button>
          <button className="next-btn" onClick={onNext}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingFinalStep;
